export default {
	'EMAIL_SAVED': 'Ваш e-mail успешно сохранён',
};



// WEBPACK FOOTER //
// ./client/lang/ru/success.js